(function ShoreExcursionsGroupIndex($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/ShoreExcursionsGroup/index/', function onload() {
			$('.item').click(function itemClicked() {
				document.location = Adzuki.base_uri + '/ShoreExcursionsGroup/view/' + $(this).data("id");
			});
		});
	});

	// custom functions
}(jQuery, window.Adzuki || {}));